define('viewmodels/Weightings_Thresholds/SanctionsOrganizationalLevelWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'SanctionsOrganizationalLevelWeightings';
    var SOLWViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        detached: detached,
        RiskAreaTabClick: RiskAreaTabClick,
        RiskLevelTabClick: RiskLevelTabClick,
        GetRiskLevelSubtabs: GetRiskLevelSubtabs,
        saveBULWeightings: saveBULWeightings,
        saveConBULWeightings: saveConBULWeightings,
        copyDataBUL: copyDataBUL,
        copyData: copyData,
        //copyConDataBUL: copyConDataBUL,
        GetRiskLevelDetails: GetRiskLevelDetails,
        addNewDivTabBULevel: addNewDivTabBULevel,
        clickedlevelId: ko.observable(),
        ClickedLevel2Id: ko.observable(),
        ClickedLevel3Id: ko.observable(),
        BusinessLevelDetailTabClick: BusinessLevelDetailTabClick,
        BusinessLevelList: ko.observableArray(),
        ClickedType: ko.observable(),
        saveBULWeightings: saveBULWeightings,
        BusinessLevelDetailsList: ko.observableArray(),
        BusinessUnitsLowestLevelList: ko.observableArray(),
        ClickedLevelDetailId: ko.observable(),
        BULWeightingsList: ko.observable(),
        ClickedLevelDetailName: ko.observable(),
        RiskAreaList: ko.observable(),
        BULWeightingsListSave: ko.observableArray(),
        ControlAreaList: ko.observableArray(),
        GetAllControlArea: GetAllControlArea,
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        countLevelEntry: ko.observable(0),
        LevelErrorStatus: ko.observable(0),
        RiskAreaTabClicked: ko.observable(),
        InputChange: InputChange,
        InputChangeEvent: ko.observable(false),
        CopyDataButtonClicked: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        PreviousClickedAreaID: ko.observable(),
        PreviousLevelID: ko.observable(),
        countLevelDetailEntry: ko.observable(),
        PreviousLevelDetailID: ko.observable(),
        LevelIDForSproc: ko.observable()
    }

    return SOLWViewModel;
    function activate() {
        }

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in SANC OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function attached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
            SOLWViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
                SOLWViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
                    if (SOLWViewModel.appsecurity.isConfigurationFreeze() == 1)
                        SOLWViewModel.appsecurity.WriteAccess(false);
                        GetAllRiskAreas();
                        GetAllControlArea();
                })
            })
            //scrollableTabs();
            var url = window.location.pathname;
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (filename == "SanctionsOrganizationalLevelWeightings") {
                $(document).on('change', 'input', function (e) {
                    GetTotalWeightingsBUL();
                    GetTotalControlWeightingsBUL();
                });
            }
            $('#RaTab').tabs();
            $('#RaTab').tabs('refresh');
            $('#RaTab').tabs({ active: 0 });
            $(document).on('keydown', 'input', function (e) {
                var id = $(this).attr('id');
                var result = '', controlID = '', rows = 0;
                if ((id.substring(0, 13)) == "txt_weighting") {
                    result = id.substring(("txt_weightingSANC").length, id.length);
                    controlID = 'txt_weightingSANC';
                    rows = SOLWViewModel.RiskFactorList().length;
                    columns = SOLWViewModel.BusinessUnitsList().length + 1;
                }
                else if ((id.substring(0, 14)) == "txt_Oweighting") {
                    result = id.substring(("txt_OweightingSANC").length, id.length);
                    controlID = 'txt_OweightingSANC';
                    rows = SOLWViewModel.RiskAreaList().length - 1;// removing the Overall SANC Inherent Weightings from the list;
                    columns = SOLWViewModel.BusinessUnitsList().length + 1;
                }
                else if ((id.substring(0, 17)) == "txt_BULweightingC") {
                    result = id.substring(("txt_BULweightingCon").length, id.length);
                    controlID = 'txt_BULweightingCon';
                    rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
                    columns = SOLWViewModel.ControlAreaList().length;
                }
                else if ((id.substring(0, 16)) == "txt_BULweighting") {
                    result = id.substring(("txt_BULweightingSANC").length, id.length);
                    controlID = 'txt_BULweightingSANC';
                    rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
                    columns = SOLWViewModel.RiskAreaList().length;
                }
                else if ((id.substring(0, 17)) == "txt_BULOweighting") {
                    result = id.substring(("txt_BULOweightingSANC").length, id.length);
                    controlID = "txt_BULOweightingSANC";
                    rows = SOLWViewModel.RiskAreaList().length - 1;
                    columns = SOLWViewModel.BusinessLevelDetailsList().length;
                }

                if (e.which == 9 && filename == "SanctionsOrganizationalLevelWeightings" && rows > 1) {
                    var columnandrownuo = result.indexOf("_");
                    if (controlID == "txt_OweightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.length));
                    } else if (controlID == "txt_weightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    else if (controlID == "txt_BULweightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    else if (controlID == "txt_BULweightingCon") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    else if (controlID == "txt_BULOweightingSANC") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    rowno = rowno + 1;

                    if (rowno == rows) {
                        rowno = 0;
                        columnno = columnno + 1;
                    }
                    for (var i = rowno; i <= rows; i++) {
                        if (rowno == rows) {
                            rowno = 0;
                            columnno = columnno + 1;
                        }
                        if (controlID == "txt_OweightingSANC") {
                            var tobefocusedid = controlID + rowno + "_" + columnno;
                        }
                        else if (controlID == "txt_weightingSANC") {
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.RAId();
                        }
                        else if (controlID == "txt_BULweightingSANC") {
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.ClickedLevelDetailId();
                        }
                        else if (controlID == "txt_BULweightingCon") {
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.ClickedLevelDetailId();
                        }
                        else if (controlID == "txt_BULOweightingSANC") {
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.ClickedLevelDetailId();
                        }

                        if ($("#" + tobefocusedid).prop('disabled')) {
                            rowno = rowno + 1;
                        }
                        else {
                            break;
                        }
                    }
                    //if (columnno > columns | columnno == columns | columnandrownuo == -1 | isNaN(rowno)) {
                    //    //do nothing to make tab work as per its functionality
                    //}
                    if (columnno > columns | columnno == columns | columnandrownuo == -1 | isNaN(rowno)) {
                        //do nothing to make tab work as per its functionality
                    }
                    else if (controlID == "txt_OweightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno;
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_weightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.RAId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_BULweightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_BULweightingCon") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                    else if (controlID == "txt_BULOweightingSANC") {
                        e.preventDefault();
                        var tobefocusedid = controlID + rowno + "_" + columnno + "_" + SOLWViewModel.ClickedLevelDetailId()
                        $("#" + tobefocusedid).focus();
                        $("#" + tobefocusedid).select();
                    }
                }
            });
            $($('#RiskAreaUl li').get(0)).trigger('click');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in SANC OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    };

    //Tab click Events
    function InputChange() {
        SOLWViewModel.InputChangeEvent(true);
    }

    function RiskAreaTabClick(data, event) {
        try {
            //SOLWViewModel.RiskAreaTabClicked(true);

            if (SOLWViewModel.appsecurity.WriteAccess() == false || SOLWViewModel.appsecurity.WriteAccess() == "false") {
                SOLWViewModel.countEntry(0);
            }
            if (SOLWViewModel.countEntry() == 0) {
                SOLWViewModel.countEntry(1);
                if (event.currentTarget.id == 'AMLinherent') {
                    $('#' + event.currentTarget.id).addClass('ui-tabs-active');
                    $('#' + event.currentTarget.id).addClass('ui-state-active');
                    $('#AMLControls').removeClass('ui-tabs-active');
                    $('#AMLControls').removeClass('ui-state-active');
                    SOLWViewModel.ClickedType("Inherent");
                    SOLWViewModel.clickedlevelId("Sanctions Inherent Risk");
                }
                else if (event.currentTarget.id == 'AMLControls') {
                    $('#' + event.currentTarget.id).addClass('ui-tabs-active');
                    $('#' + event.currentTarget.id).addClass('ui-state-active');
                    $('#AMLinherent').removeClass('ui-tabs-active');
                    $('#AMLinherent').removeClass('ui-state-active');
                    SOLWViewModel.ClickedType("Controls");
                    SOLWViewModel.clickedlevelId("Sanctions Controls");
                }
                    SOLWViewModel.PreviousClickedAreaID(event.currentTarget.id);
                    GetRiskLevelDetails();
                }
            else if ((SOLWViewModel.InputChangeEvent() || SOLWViewModel.CopyDataButtonClicked()) && SOLWViewModel.SaveButtonClick() == false) {
                SOLWViewModel.InputChangeEvent(false);
                SOLWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                        if (SOLWViewModel.PreviousClickedAreaID() == "AMLinherent") {
                            $('#btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId()).click();
                        }
                        else {
                            $('#btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId()).click();
                        }
                        //SOLWViewModel.countEntry(0);
                        if (SOLWViewModel.ErrorStatus() == 1) {
                            SOLWViewModel.ErrorStatus(0);
                            $('#' + SOLWViewModel.PreviousClickedAreaID()).addClass('ui-tabs-active ui-state-active');
                            $('#' + event.currentTarget.id).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            SOLWViewModel.SaveButtonClick(false);
                            SOLWViewModel.countEntry(0);
                            $('#' + SOLWViewModel.PreviousClickedAreaID()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + event.currentTarget.id).addClass('ui-tabs-active ui-state-active');
                            RiskAreaTabClick(data, event);
                        }
                    }
                    else if (SOLWViewModel.ErrorStatus() == 0) {
                        SOLWViewModel.countEntry(1);
                        SOLWViewModel.ErrorStatus(1);
                        $('#' + SOLWViewModel.PreviousClickedAreaID()).removeClass('ui-tabs-active ui-state-active');
                        $('#' + event.currentTarget.id).addClass('ui-tabs-active ui-state-active');
                        RiskAreaTabClick(data, event);
                    }
                });
            }
            else {
                SOLWViewModel.SaveButtonClick(false);
                SOLWViewModel.InputChangeEvent(false);
                SOLWViewModel.CopyDataButtonClicked(false);
                SOLWViewModel.countEntry(0);
                $('#' + SOLWViewModel.PreviousClickedAreaID()).removeClass('ui-tabs-active ui-state-active');
                $('#' + event.currentTarget.id).addClass('ui-tabs-active ui-state-active');
                RiskAreaTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in SANC OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function RiskLevelTabClick(data, event) {
        try {
            SOLWViewModel.ClickedLevel2Id(data.BlName);
            if (SOLWViewModel.appsecurity.WriteAccess() == false || SOLWViewModel.appsecurity.WriteAccess() == "false") {
                SOLWViewModel.countLevelEntry(0);
            }
            if (SOLWViewModel.countLevelEntry() == 0) {
                SOLWViewModel.countLevelEntry(1);
                var x = data.Bulevel.substring(2, 3);
                GetRiskLevelSubtabs(data.Bulevel, x);
            }
            else if ((SOLWViewModel.InputChangeEvent() || SOLWViewModel.CopyDataButtonClicked()) && SOLWViewModel.SaveButtonClick() == false) {
                SOLWViewModel.InputChangeEvent(false);
                SOLWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                        saveConBULWeightings();
                        if (SOLWViewModel.ErrorStatus() == 1) {
                            SOLWViewModel.ErrorStatus(0);
                            $('#' + SOLWViewModel.PreviousLevelID()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.Bulevel).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            SOLWViewModel.SaveButtonClick(false);
                            SOLWViewModel.countLevelEntry(0);
                            $('#RfTab ul li #' + data.Bulevel).addClass('ui-tabs-active ui-state-active');
                            $('#RfTab ul li #' + SOLWViewModel.PreviousLevelID()).removeClass('ui-tabs-active ui-state-active');
                            RiskLevelTabClick(data, event);
                        }
                    }
                    else {
                        SOLWViewModel.SaveButtonClick(false);
                        SOLWViewModel.countLevelEntry(0);
                        $('#RfTab ul #' + SOLWViewModel.PreviousLevelID()).removeClass('ui-tabs-active ui-state-active');
                        $('#RfTab ul #' + data.Bulevel).addClass('ui-tabs-active ui-state-active');
                        RiskLevelTabClick(data, event);
                    }
                });
            }
            else {
                SOLWViewModel.SaveButtonClick(false);
                SOLWViewModel.InputChangeEvent(false);
                SOLWViewModel.CopyDataButtonClicked(false);
                SOLWViewModel.countLevelEntry(0);
                $('#RfTab ul #' + SOLWViewModel.PreviousLevelID()).removeClass('ui-tabs-active ui-state-active');
                $('#RfTab ul #' + data.Bulevel).addClass('ui-tabs-active ui-state-active');
                RiskLevelTabClick(data, event);
            }
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in SANC OrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelDetailTabClick(data, event) {
        try {
            $('#loadingMainDivOrgLevel_SANC').show();
            $('#RiskLevelDetailsAMLTabDiv').hide();
            SOLWViewModel.ClickedLevel3Id(data.DetailName);
            if (SOLWViewModel.appsecurity.WriteAccess() == false || SOLWViewModel.appsecurity.WriteAccess() == "false") {
                SOLWViewModel.countLevelDetailEntry(0);
            }
            if (SOLWViewModel.countLevelDetailEntry() == 0) {
                SOLWViewModel.countLevelDetailEntry(1);
                addNewDivTabBULevel(data.DetailId);
                SOLWViewModel.ClickedLevelDetailId(data.DetailId);
                SOLWViewModel.ClickedLevelDetailName(data.DetailName);
                getAllBusinessUnitlowestLevels(data.DetailId);
            }
            else if ((SOLWViewModel.InputChangeEvent() || SOLWViewModel.CopyDataButtonClicked()) && SOLWViewModel.SaveButtonClick() == false) {
                SOLWViewModel.InputChangeEvent(false);
                SOLWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                        if (SOLWViewModel.PreviousClickedAreaID() == "AMLinherent") {
                            $('#btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId()).click();
                        }
                        else {
                            $('#btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId()).click();
                        }
                        //SOLWViewModel.countEntry(0);
                        if (SOLWViewModel.ErrorStatus() == 1) {
                            SOLWViewModel.ErrorStatus(0);
                            $('#' + SOLWViewModel.PreviousLevelDetailID()).addClass('ui-tabs-active ui-state-active');
                            $('#' + data.DetailId).removeClass('ui-tabs-active ui-state-active');
                        }
                        else {
                            SOLWViewModel.SaveButtonClick(false);
                            SOLWViewModel.countLevelDetailEntry(0);
                            $('#RdTab ul li #' + data.DetailId).addClass('ui-tabs-active ui-state-active');
                            $('#RdTab ul li #' + SOLWViewModel.PreviousLevelDetailID()).removeClass('ui-tabs-active ui-state-active');
                            BusinessLevelDetailTabClick(data, event);
                        }
                    }
                    else {
                        SOLWViewModel.SaveButtonClick(false);
                        SOLWViewModel.countLevelDetailEntry(0);
                        $('#RdTab ul #' + SOLWViewModel.PreviousLevelDetailID()).removeClass('ui-tabs-active ui-state-active');
                        $('#RdTab ul #' + data.DetailId).addClass('ui-tabs-active ui-state-active');
                        BusinessLevelDetailTabClick(data, event);
                    }
                });
            }
            else {
                SOLWViewModel.SaveButtonClick(false);
                SOLWViewModel.InputChangeEvent(false);
                SOLWViewModel.CopyDataButtonClicked(false);
                SOLWViewModel.countLevelDetailEntry(0);
                $('#RdTab ul #' + SOLWViewModel.PreviousLevelDetailID()).removeClass('ui-tabs-active ui-state-active');
                $('#RdTab ul #' + data.DetailId).addClass('ui-tabs-active ui-state-active');
                BusinessLevelDetailTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetail() method in BusinessLevelDetailTabClick.js';
            logger.logMessage(msg);
        }

    }

    //----------------------------------//
    function GetTotalControlWeightingsBUL() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k < SOLWViewModel.ControlAreaList().length; k++) {

            var sum = parseFloat(0);
            for (var i = 0; i < SOLWViewModel.BusinessUnitsLowestLevelList().length; i++) {

                var x = "#txt_BULweightingCon" + i + "_" + k + "_" + SOLWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k;
            if (isNaN(sum)) {
                $("#txt_BULweightingCon" + rowcount + SOLWViewModel.ClickedLevelDetailId()).val(0);
            } else {
                $("#txt_BULweightingCon" + rowcount + SOLWViewModel.ClickedLevelDetailId()).val(sum);
            }

            if (sum == 100) {
                $("#txt_BULweightingCon" + rowcount + SOLWViewModel.ClickedLevelDetailId()).css('color', '#000000');
                $("#txt_BULweightingCon" + rowcount + SOLWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc");
            }
            else {
                $("#txt_BULweightingCon" + rowcount + SOLWViewModel.ClickedLevelDetailId()).css('color', 'red');
        }
    }
    }

    function GetTotalWeightingsBUL() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k < SOLWViewModel.RiskAreaList().length; k++) {

            var sum = parseFloat(0);
            for (var i = 0; i < SOLWViewModel.BusinessUnitsLowestLevelList().length; i++) {

                var x = "#txt_BULweightingSANC" + i + "_" + k + "_" + SOLWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k;
            if (isNaN(sum)) {
                $("#txt_BULweightingSANC" + rowcount + SOLWViewModel.ClickedLevelDetailId()).val(0);
            }
            else {
                $("#txt_BULweightingSANC" + rowcount + SOLWViewModel.ClickedLevelDetailId()).val(sum);
            }

            if (sum == 100) {
                $("#txt_BULweightingSANC" + rowcount + SOLWViewModel.ClickedLevelDetailId()).css('color', '#000000');
                $("#txt_BULweightingSANC" + rowcount + SOLWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc");
            }
            else {
                $("#txt_BULweightingSANC" + rowcount + SOLWViewModel.ClickedLevelDetailId()).css('color', 'red');
        }
    }
    }

    function addNewDivTabBULevel(BuDetailId) {
        try {
            $('#RiskLevelDetailsTabDiv').empty();
            $('#RiskLevelDetailsTabDiv').append(
          '<div id="AMLTabDiv-' + BuDetailId + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in addNewDivTabBULevel.js';
            logger.logMessage(msg);
        }
    }

    function GetAllControlArea() {
        try {
            $.ajax({
                url: "/api/ControlArea/GetAllControlArea?Type=SANC",
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllControlArea() method in SANC OrganizationalLevelWeightings.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    var mappedAllRiskLevels = $.map(jsonResult, function (result) {
                        return new ControlAreas(result);
                    });
                    SOLWViewModel.ControlAreaList(mappedAllRiskLevels);
                }
                else {
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SancHmViewModel), true);
                }
                }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetAllFinalRiskLevel() method in SanctionsInherentHeatMap.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsInherentHeatMap.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsInherentHeatMap.js';
                logger.logMessage(msg);
            }
        }
    }
    function GetRiskLevelDetails() {
        try {

            $.ajax({
                url: "/api/Configuration/getAllDistinctBusinessLevels ",
                type: "GET",
                //async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in SANC OrganizationalLevelWeightings.js';
            logger.logMessage(msg);

        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null && jsonResult.length > 0) {
                    var MappedBUModelList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });
                    SOLWViewModel.BusinessLevelList(MappedBUModelList);

                    $('#RfTab').tabs();
                    $('#RfTab').tabs('refresh');
                    $('#RfTab').tabs({ active: 0 });
                    $($('#RiskFactorUl li').get(0)).trigger('click');
                }
                else {
                    app.showMessage("Organizational Levels configurations not in place", "Error", ["OK"]);
               }
                }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in SANC OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in SANC OrganizationalLevelWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in SANC OrganizationalLevelWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetRiskLevelSubtabs(FullLevelID, LevelID) {
        try {
            SOLWViewModel.PreviousLevelID(FullLevelID);
            for (var i = 0; i < SOLWViewModel.BusinessLevelList().length ; i++) {
                if (SOLWViewModel.BusinessLevelList()[i].Bulevel == SOLWViewModel.PreviousLevelID()) {
                    SOLWViewModel.LevelIDForSproc(SOLWViewModel.BusinessLevelList()[i].BlId);
                }
            }
            $.ajax({
                url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                data: { "levelid": SOLWViewModel.LevelIDForSproc() },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (!(jsonResult == "")) {
                    if (jsonResult != null && jsonResult[0].BuLevelDetailName != null) {
                        $('#NoSublevelsSanc').hide();
                        $('#RiskLevelTabDiv').show();
                        var mappedBULevelsList = $.map(jsonResult, function (result) {
                            return new BusinessLevelDetail(result);
                        });
                        SOLWViewModel.BusinessLevelDetailsList(mappedBULevelsList);

                        $('#RdTab').tabs();
                        $('#RdTab').tabs('refresh');
                        $('#RdTab').tabs({ active: 0 });
                        $($('#RiskLevelDetailUl li').get(0)).trigger('click');
                        scrollableTabs();
                    }
                    else
                    {
                        logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(SOLWViewModel), true);

                    }
                }
                else
                {
                    $('#NoSublevelsSanc').show();
                    $('#RiskLevelTabDiv').hide();
                }
                }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }




    }


    function getAllBusinessUnitlowestLevels(entityId) {
        try {
            SOLWViewModel.PreviousLevelDetailID(entityId);
            GetBUlowestLevelsAjax = {
                url: "/api/Configuration/getAllLowestLevelUnitsByLevels",
                data: { "entityId": entityId, "asst_type": "SANC" },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlowestLevelsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnitlowestLevels() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {
                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnits(result);
                    });
                    SOLWViewModel.BusinessUnitsLowestLevelList(mappedBusinessUnits);
                    if (SOLWViewModel.ClickedType() == "Inherent") {
                        GetBUlevelWeightings();
                    }
                    else {
                        GetCULevelWeightings();
                    }
                }
                else {
                    app.showMessage("Business Units configurations not in place", "Error", ["OK"]);
                    $("#NoBusinessUnitserrorORGSANC").show();
                    $("#RaTab").hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnitlowestLevels() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    };
    function GetAllRiskAreas() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllRiskAreas",
                data: { "AssessmentType": "SANC", "AreaType": "ALL" },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "" && jsonResult[0].RiskAreaName != null) {
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        return RiskAreaModelObj;
                    });
                    SOLWViewModel.RiskAreaList(mappedRiskAreaList);
                }
                else {
                    app.showMessage("Risk Area configurations not in place.", "Error", ["OK"]);
                    $("#RaTab").hide();
                    $("#NoRiskAreaserrorORGSANC").show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    };
    function GetCULevelWeightings() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetCULevelWeightings",
                data: { "RiskAreaType": "SANC", "DeUid": SOLWViewModel.ClickedLevelDetailId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkBULevelWeighting = 1;
                    SOLWViewModel.BULWeightingsList(mappedWeightings);

                    CULevelWeightingsTable(checkBULevelWeighting);
                    // GetTotalWeightingsBUL();
                }
                else {
                    checkBULevelWeighting = 0;
                    CULevelWeightingsTable(checkBULevelWeighting);
                    //  GetTotalWeightingsBUL();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function GetBUlevelWeightings() {
        try {
            $.ajax({
                url: "/api/WeightingsThresholds/GetBULevelWeightings",
                data: { "RiskAreaType": "SANC", "DeUid": SOLWViewModel.ClickedLevelDetailId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkBULevelWeighting = 1;
                    SOLWViewModel.BULWeightingsList(mappedWeightings);

                    BULevelWeightingsTable(checkBULevelWeighting);
                    // GetTotalWeightingsBUL();
                }
                else {
                    checkBULevelWeighting = 0;
                    BULevelWeightingsTable(checkBULevelWeighting);
                    //  GetTotalWeightingsBUL();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in SanctionsInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function CULevelWeightingsTable(checkBULevelWeighting) {
        try {
            if (SOLWViewModel.BULWeightingsList() == undefined) {
                SOLWViewModel.BULWeightingsList([]);
            }
            var selectedRow, selectedCol;
            var rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
            var j = SOLWViewModel.ControlAreaList().length;
            for (var i = 0; i < SOLWViewModel.ControlAreaList().length; i++) {
                colHeight = Math.ceil(SOLWViewModel.ControlAreaList()[i].ControlAreaName.length / 25);
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            bucoulmnheight = tdHeight / 2;

            for (var i = 0; i < SOLWViewModel.BusinessLevelDetailsList().length; i++) {
                var id = document.getElementById('AMLTabDiv-' + SOLWViewModel.BusinessLevelDetailsList()[i].DetailId);
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + SOLWViewModel.BusinessLevelDetailsList()[i].DetailId).innerHTML = "";
                }
            }
            var TabData =
'<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SOLWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnSANCInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + SOLWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveConBULWeightings" title="Click to save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-4 no-padding control-label control-label-border">' + SOLWViewModel.clickedlevelId() + '&nbsp<b>&rArr;</b>&nbsp' + SOLWViewModel.ClickedLevel2Id() + '&nbsp<b>&rArr;</b>&nbsp' + SOLWViewModel.ClickedLevel3Id() + '</label>';
            TabData += '</div><label id="lblSANCError-' + SOLWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +

                     //'<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label">' + SOLWViewModel.ClickedLevelDetailName() + '</label>' +
            //Corner cell
            '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Control Areas</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Business Units</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>';
            //Corner cell end
            //Header Business units
            TabData += '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SOLWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
                '<table>' +
                    '<tr>';


            for (var i = 0 ; i < SOLWViewModel.ControlAreaList().length; i++) {
                TabData += '<td  style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + SOLWViewModel.ControlAreaList()[i].ControlAreaId + '" title="' + SOLWViewModel.ControlAreaList()[i].ControlAreaName + '">' + SOLWViewModel.ControlAreaList()[i].ControlAreaName + '</td>';
            }
            TabData += '</tr>' +
                              '</table>' +
                             '</div>';
            //Header Business units end
            //Row headers
            TabData += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SOLWViewModel.ClickedLevelDetailId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < rows; i++) {
                selectedRow = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                var factText = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                TabData += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                TabData += SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                TabData += '</td></tr>';
            }
            TabData += '</table></div>';

            //Row headers end
            //data starts
            TabData += '<div class="wclscscroll table-content" id="clscroll-content' + SOLWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
    '<table id="tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + '"><tbody>';
            for (var i = 0; i < rows; i++) {
                selectedRow = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                var factText = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                TabData += '<tr id="' + SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID + '">';
                for (var k = 0; k < (j) ; k++) {
                    TabData += '<td id="' + SOLWViewModel.ControlAreaList()[k].ControlAreaId + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    selectedCol = SOLWViewModel.ControlAreaList()[k].ControlAreaId;
                    if (SOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() == 'NOT APPLICABLE') {

                        var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                        SOLWViewModel.BULWeightingsList().push(newObj);
                        TabData += '<input type="text" disabled  class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="0" style="background-color: #ccc;"></input><span class="input-group-addon">%</span>';
                        TabData += '</div></td>';
                    }
                    else {

                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < SOLWViewModel.BULWeightingsList().length; val++) {
                                if (SOLWViewModel.BULWeightingsList()[val].Id == SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID && SOLWViewModel.BULWeightingsList()[val].BuId == SOLWViewModel.ControlAreaList()[k].ControlAreaId) {


                                    TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_BULweightingCon' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="' + SOLWViewModel.BULWeightingsList()[val].WeightingValue + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SOLWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SOLWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingCon' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';
                    }
                }
                TabData += '</tr>'
            }
            TabData += '</tbody></table></div>';
            //Data ends
            //Total  cell

            TabData += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell  label-info">';
            TabData += "Total"
            TabData += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>';
            //Total cell end
            //Total Data
            TabData += '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SOLWViewModel.ClickedLevelDetailId() + '">' +
                 '<table>' +
                     '<tr>'
            for (l = 0; l < SOLWViewModel.ControlAreaList().length; l++) {
                TabData += '<td style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabData += '<input type="text" disabled style="background-color:#cccccc" class="form-control form-controlWT" id="' + 'txt_BULweightingCon' + l + SOLWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                TabData += '</td>';
            }
            TabData += '</tr>' +
            '</table>'

            document.getElementById('AMLTabDiv-' + SOLWViewModel.ClickedLevelDetailId()).innerHTML = TabData;
            ko.applyBindingsToNode($('#btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId()), { click: SOLWViewModel.saveConBULWeightings }, SOLWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy-' + SOLWViewModel.ClickedLevelDetailId()), { click: SOLWViewModel.copyData }, SOLWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {

                    ko.applyBindingsToNode($('#txt_BULweightingCon' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId()), { event: { keyup: SOLWViewModel.InputChange } }, SOLWViewModel);

                }
            }
            GetTotalControlWeightingsBUL();
            ImplementControlsSecurity();
            $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-row-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollTop());
                $("#clscroll-column-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
                $("#clscroll-column-footer" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-headers" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-footer" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-footer" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-row-headers" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-row-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollTop());
            });
            $('#loadingMainDivOrgLevel_SANC').hide();
            $('#RiskLevelDetailsAMLTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in SanctionsOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------------------------------------------->
    //this crates the table that will be binded to the html dynamically
    function BULevelWeightingsTable(checkBULevelWeighting) {
        try {
            if (SOLWViewModel.BULWeightingsList() == undefined) {
                SOLWViewModel.BULWeightingsList([]);
            }
            var selectedRow, selectedCol;
            var rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
            var j = SOLWViewModel.RiskAreaList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < j; i++) {
                colHeight = Math.ceil(SOLWViewModel.RiskAreaList()[i].RiskAreaName.length / 13);
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucoulmnheight = tdHeight / 2;
            for (var i = 0; i < SOLWViewModel.BusinessLevelDetailsList().length; i++) {
                var id = document.getElementById('AMLTabDiv-' + SOLWViewModel.BusinessLevelDetailsList()[i].DetailId);
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + SOLWViewModel.BusinessLevelDetailsList()[i].DetailId).innerHTML = "";
                }
            }
            //------------------table body starts here
            var TabData =
        '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (SOLWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnSANCInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnSANCCopy-' + SOLWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyDataBUL" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveBULWeightings" title="Click to save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-4 no-padding control-label control-label-border">' + SOLWViewModel.clickedlevelId() + '&nbsp<b>&rArr;</b>&nbsp' + SOLWViewModel.ClickedLevel2Id() + '&nbsp<b>&rArr;</b>&nbsp' + SOLWViewModel.ClickedLevel3Id() + '</label>' +
                      //'<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label">' + SOLWViewModel.ClickedLevelDetailName() + '</label>' +
                       '</div><label id="lblSANCError-' + SOLWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
            //Corner cell
            '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Risk Areas</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Business Units</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>';
            //Corner cell end

            //Header Business units
            TabData += '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + SOLWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
                '<table>' +
                    '<tr>';


            for (var i = 0 ; i < j; i++) {
                TabData += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + SOLWViewModel.RiskAreaList()[i].RiskAreaId + '" title="' + SOLWViewModel.RiskAreaList()[i].RiskAreaName + '">' + SOLWViewModel.RiskAreaList()[i].RiskAreaName + '</th>';
            }
            TabData += '</tr>' +
                              '</table>' +
                             '</div>';
            //Header Business units end
            //Row headers
            TabData += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + SOLWViewModel.ClickedLevelDetailId() + '" style="width:100%">' +
                '<table>';
            for (var i = 0; i < rows; i++) {
                selectedRow = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                var factText = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;

                TabData += '<tr><td  style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader ">';
                TabData += SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                TabData += '</td></tr>';
            }
            TabData += '</table></div>';
            //Row headers end
            //Data 
            TabData += '<div class="wclscscroll table-content" id="clscroll-content' + SOLWViewModel.ClickedLevelDetailId() + '" style="width:65%;">' +
'<table id="tblSACNWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + '" ><tbody>';
            for (var i = 0; i < rows; i++) {

                selectedRow = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                var factText = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name;
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                TabData += '<tr id="' + SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID + '">';
                for (var k = 0; k < (j) ; k++) {
                    TabData += '<td  id="' + SOLWViewModel.RiskAreaList()[k].RiskAreaId + '"style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    selectedCol = SOLWViewModel.RiskAreaList()[k].RiskAreaId;
                    if (SOLWViewModel.BusinessUnitsLowestLevelList()[i].BuStatus.toUpperCase() == 'NOT APPLICABLE') {

                        var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                        SOLWViewModel.BULWeightingsList().push(newObj);
                        TabData += '<input type="text" disabled  class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingSANC' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="0" style="background-color: #ccc;"></input><span class="input-group-addon">%</span>';
                        TabData += '</div></td>';
                    }
                    else {

                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < SOLWViewModel.BULWeightingsList().length; val++) {
                                if (SOLWViewModel.BULWeightingsList()[val].Id == SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID && SOLWViewModel.BULWeightingsList()[val].BuId == SOLWViewModel.RiskAreaList()[k].RiskAreaId) {


                                    TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_BULweightingSANC' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="' + SOLWViewModel.BULWeightingsList()[val].WeightingValue + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                SOLWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingSANC' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            SOLWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULweightingSANC' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';
                    }

                }

                TabData += '</tr>';

            }
            TabData += '</tbody></table></div>';
            //Data ends
            //Total  cell

            TabData += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabData += "Total"
            TabData += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>';
            //Total cell end
            //Total Data
            TabData += '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + SOLWViewModel.ClickedLevelDetailId() + '">' +
                 '<table>' +
                     '<tr>'
            for (l = 0; l < SOLWViewModel.RiskAreaList().length; l++) {
                TabData += '<td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabData += '<input type="text" disabled style="background-color:#cccccc" class="form-control form-controlWT" id="' + 'txt_BULweightingSANC' + l + SOLWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                TabData += '</td>';
            }
            TabData += '</tr>' +
            '</table>'
            //total data ends

            document.getElementById('AMLTabDiv-' + SOLWViewModel.ClickedLevelDetailId()).innerHTML = TabData;
            ko.applyBindingsToNode($('#btnSANCSave-' + SOLWViewModel.ClickedLevelDetailId()), { click: SOLWViewModel.saveBULWeightings }, SOLWViewModel);
            ko.applyBindingsToNode($('#btnSANCCopy-' + SOLWViewModel.ClickedLevelDetailId()), { click: SOLWViewModel.copyDataBUL }, SOLWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {

                    ko.applyBindingsToNode($('#txt_BULweightingSANC' + i + '_' + k + '_' + SOLWViewModel.ClickedLevelDetailId()), { event: { keyup: SOLWViewModel.InputChange } }, SOLWViewModel);

                }
            }
            GetTotalWeightingsBUL();
            ImplementSecurity();
            $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-row-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollTop());
                $("#clscroll-column-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
                $("#clscroll-column-footer" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-headers" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-column-footer" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft($("#clscroll-column-footer" + SOLWViewModel.ClickedLevelDetailId()).scrollLeft());
            });

            $("#clscroll-row-headers" + SOLWViewModel.ClickedLevelDetailId()).scroll(function () {
                $("#clscroll-content" + SOLWViewModel.ClickedLevelDetailId()).scrollTop($("#clscroll-row-headers" + SOLWViewModel.ClickedLevelDetailId()).scrollTop());
            });
            $('#loadingMainDivOrgLevel_SANC').hide();
            $('#RiskLevelDetailsAMLTabDiv').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in SanctionsOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementSecurity() {
        try {
            if (SOLWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblSACNWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblSACNWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementSecurity() method in SanctionsOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementControlsSecurity() {
        try {
            if (SOLWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementSecurity() method in SanctionsOrganizationalLevelWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyData() {
        try {
            SOLWViewModel.CopyDataButtonClicked(true);
            var cols = SOLWViewModel.ControlAreaList().length;
            $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeigtingsValue = [];
            rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;

            for (var i = 0; i < rows; i++) {
                var txtValue = $($('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                if (txtValue == "") {
                    $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                    $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed');
                        valid = 1;
                        break;
                    }
                    else {
                        WeigtingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SOLWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {

                SOLWViewModel.BULWeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = $('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i).id;
                    for (var j = 0; j < cols; j++) {

                        selectedColId = $('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tr').find('td').get(j).id;
                        wValue = $($('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        SOLWViewModel.BULWeightingsList().push(newObj);
                    }
                }
                $('#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId()).remove();
                CULevelWeightingsTable(1);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyDataBUL() {
        try {
            SOLWViewModel.CopyDataButtonClicked(true);
            var cols = SOLWViewModel.RiskAreaList().length;
            $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeightingsValue = [];
            rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;

            for (var i = 0; i < rows; i++) {
                var txtValue = $($('#tblSACNWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                if (txtValue == "") {
                    $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                    $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed.');
                        valid = 1;
                        break;
                    }
                    else {
                        WeightingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                SOLWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {

                SOLWViewModel.BULWeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID;
                    for (var j = 0; j < cols; j++) {

                        selectedColId = SOLWViewModel.RiskAreaList()[j].RiskAreaId;
                        wValue = WeightingsValue[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        SOLWViewModel.BULWeightingsList().push(newObj);
                    }
                }
                $('#tblSACNWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId()).remove();
                BULevelWeightingsTable(1);
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function buildsaveConBULWeightingsList() {
        try {
            SOLWViewModel.BULWeightingsListSave([]);
            var rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
            var cols = SOLWViewModel.ControlAreaList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULweightingCon' + i + '_' + j + '_' + SOLWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': SOLWViewModel.ControlAreaList()[j].ControlAreaId, 'BuId': SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID,
                        'WeightingValue': $(txtid).val()
                    });
                    SOLWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function buildSaveBULWeightingsList() {
        try {
            SOLWViewModel.BULWeightingsListSave([]);
            var rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
            var cols = SOLWViewModel.RiskAreaList().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULweightingSANC' + i + '_' + j + '_' + SOLWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': SOLWViewModel.RiskAreaList()[j].RiskAreaId, 'BuId': SOLWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID,
                        'WeightingValue': $(txtid).val()
                    });
                    SOLWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function saveConBULWeightings() {
        try {
            $('#loadingMainDivOrgLevel_SANC').show();
            $('#RiskLevelDetailsAMLTabDiv').hide();
            SOLWViewModel.SaveButtonClick(true);
            var colsBUL = SOLWViewModel.ControlAreaList().length;
            var rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
            var tableId = '#tblConWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId();
            var valid = 1;
            var check = 0;
            for (var i = 0; i < colsBUL; i++) {
                var sum = 0;

                for (var j = 0; j < rows; j++) {
                    if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                        $($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                        break;
                    }
                    else if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                        break;
                    }
                    else {
                        sum += parseFloat($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('The total for weightings across business units should be 100% for control area ' + SOLWViewModel.ControlAreaList()[i].ControlAreaName + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                SOLWViewModel.ErrorStatus(1);
                $('#loadingMainDivOrgLevel_SANC').hide();
                $('#RiskLevelDetailsAMLTabDiv').show();
            }
            if (valid == 1) {
                try {
                    buildsaveConBULWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveControlWeightingsBUL?RiskAreaType=SANC&BUL_Entity_ID=" + SOLWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(SOLWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.Id, BuId: item.BuId, WeightingValue: item.WeightingValue };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            //var mappedData = $.map(jsonResult, function (result) {
                            //    return new WeightingModel(result);
                            //});
                            SOLWViewModel.BULWeightingsList([]);
                            // SOLWViewModel.BULWeightingsList(mappedData);
                            $(tableId).remove();
                            GetCULevelWeightings();
                            GetTotalControlWeightingsBUL();
                            $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Overall Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(SOLWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SOLWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in SanctionsInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }



        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }

    }
    function saveBULWeightings() {
        try {
            $('#loadingMainDivOrgLevel_SANC').show();
            $('#RiskLevelDetailsAMLTabDiv').hide();
            SOLWViewModel.SaveButtonClick(true);
            var colsBUL = SOLWViewModel.RiskAreaList().length;
            var rows = SOLWViewModel.BusinessUnitsLowestLevelList().length;
            var tableId = '#tblSACNWeightingsBU-' + SOLWViewModel.ClickedLevelDetailId();
            var valid = 1;
            var check = 0;
            for (var i = 0; i < colsBUL; i++) {
                var sum = 0;

                for (var j = 0; j < rows; j++) {
                    if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                        $($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                        break;
                    }
                    else if ($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                        break;
                    }
                    else {
                        sum += parseFloat($($(tableId + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                    }
                }
                if (sum != 100 && sum != 0) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).show();
                        $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).text('The total for weightings across business units should be 100% for risk area ' + SOLWViewModel.RiskAreaList()[i].RiskAreaName + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                SOLWViewModel.ErrorStatus(1);
                $('#loadingMainDivOrgLevel_SANC').hide();
                $('#RiskLevelDetailsAMLTabDiv').show();
            }
            if (valid == 1) {
                try {
                    buildSaveBULWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveOverallWeightingsBUL?RiskAreaType=SANC&BUL_Entity_ID=" + SOLWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(SOLWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.Id, BuId: item.BuId, WeightingValue: item.WeightingValue };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in SanctionsInherentWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult != 0) {
                            //var mappedData = $.map(jsonResult, function (result) {
                            //    return new WeightingModel(result);
                            //});
                            SOLWViewModel.BULWeightingsList([]);
                            // SOLWViewModel.BULWeightingsList(mappedData);
                            $(tableId).remove();
                            GetBUlevelWeightings();
                            checkBULevelWeighting = 1;
                            BULevelWeightingsTable(checkBULevelWeighting);
                            GetTotalWeightingsBUL();
                            $("#lblSANCError-" + SOLWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Overall Inherent Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(SOLWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(SOLWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in SanctionsInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in SanctionsInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveBULWeightings() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function checkDecimal(value) {
        try {
            var num = parseFloat(value);
            if (num.toFixed(1) == value) {
                return true;
            }
            return num.toFixed(2) == value;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkDecimal() method in SanctionsInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    //-----------------------------------------------------------------------------------Models' definitions starts from here
    function RiskAreaModel(item) {
            var self = this;
        self.RiskAreaName = $('<div/>').html(item.RiskAreaName).text();// ko.observable($('<div/>').html(item.RiskAreaName).text());
        self.RiskAreaId = item.RiskAreaId;// ko.observable(item.RiskAreaId);
        self.RiskAreaType = $('<div/>').html(item.RiskAreaType).text();// ko.observable($('<div/>').html(item.RiskAreaType).text());
            if ($('<div/>').html(item.IsQualitative).text() == "1") {
            self.IsQualitative = true;// ko.observable(true);
            }
            else {
            self.IsQualitative = false;// ko.observable(false);
        }
        }

    function BusinessLevelModel(item) {
            var self = this;
        self.Bulevel = $('<div/>').html(item.Bulevel).text();//ko.observable($('<div/>').html(item.Bulevel).text());
        self.BlName = $('<div/>').html(item.BlName).text();//ko.observable($('<div/>').html(item.BlName).text());
        self.BlId = item.BlId;//ko.observable(item.BlId);
    }
    function BusinessLevelDetail(item) {
            var self = this;
        self.DetailId = $('<div/>').html(item.BuLevelDetailId).text();// ko.observable($('<div/>').html(item.BuLevelDetailId).text());
        self.DetailName = $('<div/>').html(item.BuLevelDetailName).text();// ko.observable($('<div/>').html(item.BuLevelDetailName).text());

        }
    function ControlAreas(item) {
            var self = this;
        self.ControlAreaId = item.ControlAreaId; //ko.observable(item.ControlAreaId);
        self.ControlAreaName = $('<div/>').html(item.ControlAreaName).text();// ko.observable($('<div/>').html(item.ControlAreaName).text());
    }
    function BusinessUnits(item) {
            var self = this;
        self.BusinessUnit_ID = item.BuId;// ko.observable(item.BuId);
        self.BusinessUnit_Name = $('<div/>').html(item.BuName).text();// ko.observable($('<div/>').html(item.BuName).text());
        self.BuAssessmentDate = $('<div/>').html(item.BuAssessmentDate).text();// ko.observable($('<div/>').html(item.BuAssessmentDate).text());
        self.BuStatus = $('<div/>').html(item.BuStatus).text();// ko.observable($('<div/>').html(item.BuStatus).text());
        }
    function WeightingModel(item) {
            var self = this;
        self.Id = item.Id;// ko.observable(item.Id);
        self.BuId = item.BuId;// ko.observable(item.BuId);
        self.WeightingValue = item.WeightingValue;// ko.observable(item.WeightingValue);
    }
});



































